import { SettingsApi } from "../../../@api";

import { IStoreContext } from "../../stores/StoreContext";
import { SettingsApiService } from "../ApiServices/SettingsApiService";
import { GenericService } from "../GenericService";

export class SettingsService extends GenericService<SettingsApi, SettingsApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, SettingsApi, SettingsApiService);
  }

  public async ensureShouldPersistAnyUserActions(): Promise<void> {
    const response: boolean = await this.apiService.settingsShouldPersistAnyUserActionsGet();
    this.storeContext.settingsStore.setPersistAnyActions(response);
  }
}
